// Expand paragraph content
const { $ } = window;

$(() => {
  // $('.expand-text-container').each(function callback() {
  //   const $this = $(this);
  //   const origHeight = $this.outerHeight();
  //   if ($this.css('height', 'auto').outerHeight() <= origHeight) {
  //     $this.find('.expand-text-btn').hide();
  //   } else {
  //     $this.css('height', `${origHeight}px`);
  //   }
  // });
  $('.expand-text-btn').on('click', function callback(e) {
    e.preventDefault();
    e.stopPropagation();
    const $this = $(this);

    $this.parent().addClass('expanded');
  });
});
